var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getPastShiftAnalyticsFunctionDef, } from '../../../../backend/features/shift/shared';
import { defaultFetcherOptions } from '../../../../ui/utils/defaultFetcherOptions';
import { handleErrorSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { useTypedPlatformFunction } from '@juvare/platform-sdk-react/ui/features/typed-platform-functions';
import React from 'react';
import useSWR from 'swr';
export const singleShiftDetailsAnalyticsFetchKey = 'singleShiftDetailsAnalytics';
export function useSingleShiftDetailsAnalytics({ row, isExpanded }) {
    const getPastShiftAnalyticsPlatformFn = useTypedPlatformFunction(getPastShiftAnalyticsFunctionDef);
    const fetchPastShiftAnalytics = (shiftId, isExpanded) => __awaiter(this, void 0, void 0, function* () {
        return yield getPastShiftAnalyticsPlatformFn({
            shiftId,
            returnEmpty: !isExpanded,
        });
    });
    const fetchEmpty = (row) => {
        return new Promise((resolve) => {
            var _a, _b, _c, _d, _e;
            resolve({
                pendingHours: (_a = row.pendingHours) !== null && _a !== void 0 ? _a : 0,
                approvedHours: (_b = row.approvedHours) !== null && _b !== void 0 ? _b : 0,
                deniedHours: (_c = row.deniedHours) !== null && _c !== void 0 ? _c : 0,
                volunteerCount: (_d = row.volunteerCount) !== null && _d !== void 0 ? _d : 0,
                positionParticipants: (_e = row.positionParticipants) !== null && _e !== void 0 ? _e : [],
            });
        });
    };
    const { data: analytics, mutate, isLoading, error, } = useSWR([singleShiftDetailsAnalyticsFetchKey, row, isExpanded], ([, paramsRow, paramsIsExpanded]) => {
        return paramsIsExpanded
            ? fetchPastShiftAnalytics(paramsRow.id, paramsIsExpanded).catch(handleErrorSnackbar)
            : fetchEmpty(paramsRow);
    }, defaultFetcherOptions);
    const fetchAnalytics = React.useCallback(() => __awaiter(this, void 0, void 0, function* () {
        yield mutate();
    }), [mutate]);
    return {
        fetchAnalytics,
        data: Object.assign(Object.assign({}, row), analytics),
        error,
        isLoading,
    };
}
